<template>
  <cms-page :content="cmsPage"></cms-page>
</template>

<script>
import CmsPage from '~/components/cms/CmsPage'
export default {
  name: 'LandingView',
  components: { CmsPage },
  props: {
    cmsPage: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
